import { useState, useEffect } from 'react';
import { Manager } from '../../../game/manager';
import { ProgressBar } from './ProgressBar';

export const ManagerProgressBar: React.FC<{
  manager: Manager;
  containerStyle?: React.CSSProperties;
  height?: number;
}> = ({ manager, containerStyle, height = 16 }) => {
  const [fill, setFill] = useState(0);

  useEffect(() => {
    if (!manager) {
      return;
    }
    let animationFrameRef: any;

    const updateFill = () => {
      if (manager.nextAirplaneAt) {
        let p = 1 - (manager.nextAirplaneAt.getTime() - Date.now()) / (1000 / manager.getUpgradeValue('airplanes_per_second'));
        setFill(p);
      }
      animationFrameRef = requestAnimationFrame(updateFill);
    };

    animationFrameRef = requestAnimationFrame(updateFill);

    return () => cancelAnimationFrame(animationFrameRef);
  }, [manager]);

  return <ProgressBar fill={fill} height={height} containerStyle={containerStyle} />;
};
